import { useEffect } from "react";

const HIDE_CHAT_STYLE_ID = "chat-hide-style";
export const hideSupportChat = () => {
  const hideStyle = document.getElementById(HIDE_CHAT_STYLE_ID);
  if (!hideStyle) {
    const style = document.createElement("style");
    style.id = HIDE_CHAT_STYLE_ID;
    style.innerHTML = `
      #amazon-connect-chat-widget {
        display: none;
      }
    `;
    document.head.appendChild(style);
  }
};

export const showSupportChat = () => {
  const hideStyle = document.getElementById(HIDE_CHAT_STYLE_ID);
  if (hideStyle) {
    document.head.removeChild(hideStyle);
  }
};

export function useHideSupportChat() {
  useEffect(() => {
    hideSupportChat();

    return () => {
      showSupportChat();
    };
  }, []);
}
